<app-modal title="Importer un client depuis le legacy" size="md" closeLabel="Fermer" (closed)="annuler()">
  <div class="formulaire_import">
    <!-- `app-select` travaille sur des CLÉS, pas sur des objets : les options
         portent le code instit, et la fiche est retrouvée à la sélection. -->
    <app-form-field label="Fiche annuaire à importer" [required]="true">
      <app-select
        label="Sélectionner une fiche"
        trigger="field"
        [clearable]="true"
        selectionMode="single"
        [fullWidth]="true"
        [options]="optionsInstitutions()"
        [selected]="institutionsSelectionnees()"
        (selectionChange)="choisirInstitution($event)"
      />
    </app-form-field>

    @if (institutionChoisie(); as institution) {
      <div class="fiche_resume">
        <div class="info_ligne">
          <p class="libelle_info">Label</p>
          <p>{{ institution.label }}</p>
        </div>
        <div class="info_ligne">
          <p class="libelle_info">Désactivé</p>
          <p>{{ institution.disabled ? 'Oui' : 'Non' }}</p>
        </div>
        <div class="info_ligne">
          <p class="libelle_info">Archivage actif</p>
          <p>{{ institution.isActiveArchiving ? 'Oui' : 'Non' }}</p>
        </div>
      </div>

      @if (institution.baseExistanteDansRegistre) {
        <div class="fiche_resume">
          <p class="titre_section">Base de données (existante dans le registre)</p>
          <div class="info_ligne">
            <p class="libelle_info">Serveur</p>
            <p>{{ institution.serveur }}</p>
          </div>
          <div class="info_ligne">
            <p class="libelle_info">Base</p>
            <p>{{ institution.baseDeDonnees }}</p>
          </div>
          <div class="info_ligne">
            <p class="libelle_info">Utilisateur</p>
            <p>{{ institution.utilisateur }}</p>
          </div>
        </div>
      } @else {
        <form [formGroup]="nouvelleBaseForm" class="formulaire_nouvelle_base">
          <p class="titre_section">Base inconnue du registre : elle sera créée avec son secret Key Vault</p>

          <app-form-field label="Nom dans le registre (StoreName)" [required]="true">
            <app-input formControlName="storeName" [maxLength]="longueurs.nomBaseDeDonnees" />
          </app-form-field>

          <app-form-field label="Serveur" [required]="true">
            <app-input formControlName="serveur" [maxLength]="longueurs.serveur" />
          </app-form-field>

          <app-form-field label="Base de données" [required]="true">
            <app-input formControlName="baseDeDonnees" [maxLength]="longueurs.nomBaseDeDonnees" />
          </app-form-field>

          <app-form-field label="Utilisateur">
            <app-input formControlName="utilisateur" [maxLength]="longueurs.utilisateur" />
          </app-form-field>

          <app-form-field label="Mot de passe">
            <app-input
              type="password"
              revealable
              autocomplete="new-password"
              formControlName="motDePasse"
              [maxLength]="longueurs.secret"
            />
            @if (motDePasseDepuisAnnuaire()) {
              <span appFieldHint>Le mot de passe de l'annuaire sera repris (saisir une valeur pour le remplacer)</span>
            }
          </app-form-field>
        </form>
      }
    }
  </div>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!peutValider()" (click)="valider()">Importer</button>
  </div>
</app-modal>
